module.exports = __webpack_public_path__ + "static/media/tech.2243ed40.png";